import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ReactivePayment from '@/pages/reactive-payment/ReactivePayment.vue';

export default {
  path: '/reactive-payment',
  name: 'Reativar Pagamento',
  components: {
    mainContent: ReactivePayment,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'allow-payment',
    },
    breadcrumb: {
      title: 'Reativar Pagamento',
      paths: [{ title: 'Reativar Pagamento' }],
    },
  },
};
